import { CHARACTERS, type ModeId, type WorldId } from './catalog';

export const CHARACTER_ATLAS_PATH = 'art/characters.webp';
export const CHARACTER_ATLAS_WIDTH = 1254;
export const CHARACTER_ATLAS_HEIGHT = 1254;
export const CHARACTER_ATLAS_COLUMNS = 4;
export const CHARACTER_ATLAS_ROWS = 3;

export const WORLD_ART_PATHS: Record<WorldId, string> = {
  wonderland: 'art/world-wonderland.webp',
  'looking-glass': 'art/world-looking-glass.webp',
  dracula: 'art/world-dracula.webp',
  frankenstein: 'art/world-frankenstein.webp',
  oz: 'art/world-oz.webp',
  pinocchio: 'art/world-pinocchio.webp',
};

export const GAME_MODE_ART_PATHS: Record<ModeId, string> = {
  flight: 'art/mode-flight.webp',
  fall: 'art/mode-fall.webp',
  swipe: 'art/mode-swipe.webp',
  crossing: 'art/mode-crossing.webp',
};

export const SWIPE_ITEM_ART_PATHS: Record<WorldId, { target: string; hazard: string }> = {
  wonderland: { target: 'art/swipe/wonderland-target.webp', hazard: 'art/swipe/wonderland-hazard.webp' },
  'looking-glass': { target: 'art/swipe/looking-glass-target.webp', hazard: 'art/swipe/looking-glass-hazard.webp' },
  dracula: { target: 'art/swipe/dracula-target.webp', hazard: 'art/swipe/dracula-hazard.webp' },
  frankenstein: { target: 'art/swipe/frankenstein-target.webp', hazard: 'art/swipe/frankenstein-hazard.webp' },
  oz: { target: 'art/swipe/oz-target.webp', hazard: 'art/swipe/oz-hazard.webp' },
  pinocchio: { target: 'art/swipe/pinocchio-target.webp', hazard: 'art/swipe/pinocchio-hazard.webp' },
};

export function publicAsset(path: string): string {
  if (typeof document === 'undefined' || !document.baseURI) return `./${path}`;
  return new URL(path, document.baseURI).href;
}

export function characterAtlasFrame(characterId: string) {
  const index = Math.max(0, CHARACTERS.findIndex((character) => character.id === characterId));
  const width = CHARACTER_ATLAS_WIDTH / CHARACTER_ATLAS_COLUMNS;
  const height = CHARACTER_ATLAS_HEIGHT / CHARACTER_ATLAS_ROWS;
  const column = index % CHARACTER_ATLAS_COLUMNS;
  const row = Math.floor(index / CHARACTER_ATLAS_COLUMNS);
  return { index, column, row, x: column * width, y: row * height, width, height };
}
